import { debounce } from '@fastcampus/browser-util';

export const intersectionObserver = (container, className) => {
  const intersectionCallback = () => {

    const { top, bottom } = container.getBoundingClientRect();

    if (top < window.innerHeight && bottom >= 0) {
      if (!container.classList.contains(className)) {
        container.classList.add(className);
      }
    }
  }

  window.addEventListener('scroll', () => debounce(intersectionCallback, 300));
}